import { render } from "./Sent_vacancies.vue?vue&type=template&id=31b4618c&scoped=true"
import script from "./Sent_vacancies.vue?vue&type=script&lang=js"
export * from "./Sent_vacancies.vue?vue&type=script&lang=js"

import "./Sent_vacancies.vue?vue&type=style&index=0&id=31b4618c&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b4618c"]])

export default __exports__